(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interactive_customer_guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const ICONS = {
      houseplant: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20.998 3v2a7 7 0 0 1-7 7h-1v1h5v7a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-7h5v-3a7 7 0 0 1 7-7zm-15.5-1a7.49 7.49 0 0 1 6.124 3.169A7.96 7.96 0 0 0 9.998 10v1h-.5a7.5 7.5 0 0 1-7.5-7.5V2z"></path></svg>',
      cannabis: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.5 22v-4.65c-.5.78-1.5 1.74-3.47 2.46c0 0 .5-1.71 1.91-2.86c-1.3.28-3.26.24-5.94-.95c0 0 2.47-1.41 5.28-1.03C7.69 14 5.7 12.08 4.17 8.11c0 0 4.5 1.23 6.74 5.03C8.88 8.24 12 2 12 2c2.43 5.47 1.91 9.1 1.12 11.1c2.25-3.77 6.71-4.99 6.71-4.99c-1.53 3.97-3.52 5.89-5.11 6.86C17.53 14.59 20 16 20 16c-2.68 1.19-4.64 1.23-5.94.95c1.41 1.15 1.91 2.86 1.91 2.86c-1.97-.72-2.97-1.68-3.47-2.46V22z"></path></svg>',
      veggarden: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="24" height="24" viewBox="0 0 48 48"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M22.965 9.163c-1.16-1.104-2.826-1.653-4.998-1.12a5.14 5.14 0 0 0-2.077-1.666c-1.336-.574-3.013-.562-4.904.525c-1.978.923-2.931 2.28-3.194 3.704c-.178.968-.023 1.886.232 2.61c-1.678 1.468-2.183 3.144-1.942 4.723c.209 1.366.955 2.533 1.687 3.325a4.1 4.1 0 0 0-.038 1.678c.31-.22.457-.322.794-.459c.55-.224 1-.25 1.5-.25c1.575 0 2.486.183 3.988.6a10 10 0 0 1 2.431 1.008l.284-.122a2 2 0 0 1 1.135-.136l3.513.607a14 14 0 0 1-.233-2.197a9.48 9.48 0 0 1 5.022-8.572a4.1 4.1 0 0 0-1.438-.972c-.23-1.053-.761-2.333-1.762-3.286m-9.826 1.117a1 1 0 0 1 1.34.453l.791 1.6l1.613-1.727a1 1 0 0 1 1.462 1.363l-2.127 2.278l.803 1.621l1.331-1.21a1 1 0 0 1 1.346 1.478l-1.755 1.595l1.056 2.134a1 1 0 0 1-1.793.886l-1.095-2.213l-1.964.397a1 1 0 0 1-.397-1.958l1.444-.292l-.796-1.607l-3.039.457a1 1 0 1 1-.298-1.976l2.406-.362l-.781-1.579a1 1 0 0 1 .453-1.338"></path><path d="m24.136 24.695l-.508-.099a8 8 0 0 1-.394-1.523l-.015-.06c-.102-.417-.17-.784-.176-1.06a7.6 7.6 0 0 1 2.423-5.72q.092-.087.187-.151c2.015-1.8 4.833-2.113 7.015-.327c-.025-2.452.97-4.848 3.38-6.238l.845 1.462c-2.041 1.177-2.8 3.38-2.462 5.735c4.655-1.53 8.278 2.873 6.918 7.942a7.85 7.85 0 0 1-2.547 3.977l-.61-.213c-1.807-.627-4.082-1.386-5.9-1.887c-1.768-.488-4.043-.993-5.863-1.373a196 196 0 0 0-2.293-.465m13.418-4.709a1 1 0 0 1 1.172.79a5.06 5.06 0 0 1-1.803 4.95a.998.998 0 1 1-1.26-1.552a3.07 3.07 0 0 0 1.1-3.017a1 1 0 0 1 .79-1.17M10.236 41.998c3-.167 4.856-1.02 6-2.269c.455.61 1.218.964 2.044.834a119 119 0 0 0 3.098-.531v-4.685h2.23v4.254c2.82-.57 6.25-1.353 10.031-2.406v-2.961h2.23v2.32c1.523-.453 3.092-.948 4.691-1.488a2.034 2.034 0 0 0 0-3.891a137 137 0 0 0-11.38-3.293v6.352h-2.229v-6.877c-3.69-.838-6.71-1.37-8.671-1.68a2.12 2.12 0 0 0-2.044.835c-1.144-1.25-3-2.103-6-2.27a1.063 1.063 0 0 0-1.113 1.085c.026 1.813.137 3.253.515 4.376c-1.225.464-2.38 1.4-3.436 2.809c-.27.36-.27.857 0 1.217c1.047 1.397 2.193 2.33 3.406 2.797c-.322 1.09-.45 2.52-.483 4.384a1.063 1.063 0 0 0 1.11 1.088m2.199-10.972l-2.007.76c-.556.21-1.18.621-1.84 1.334c.653.706 1.271 1.116 1.822 1.328l1.918.739l-.582 1.969c-.171.58-.286 1.374-.347 2.488c2.15-.33 3.058-1.127 3.527-1.852c.675-1.043.878-2.565.878-4.672s-.203-3.628-.878-4.671c-.47-.726-1.38-1.523-3.533-1.854c.057 1.08.17 1.838.358 2.399z"></path></g></svg>',
      mite: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Spider_mite_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="24" height="24">',
      thrips: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Thrips_adult_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="20" height="20">',
      aphid: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Aphid_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="20" height="20">',
      fly: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Fly_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="24" height="24">',
      mealybug: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Mealybug_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="20" height="20">',
      beetleGrub: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Larvae_2_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="20" height="20">',
      pest: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Stink_bug_adult_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="20" height="20">',
      caterpillar: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Caterpillar_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="20" height="20">',
      whitefly: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Whitefly_adult_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="20" height="20">',
      leafminer: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Fly_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width="24" height="24">',
      cutFlower: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" width="24" height="24" viewBox="0 0 24 24"><path d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z"></path><path fill="currentColor" d="M10.499 2.601C10.89 2.299 11.42 2 12 2s1.11.299 1.501.601c.424.327.836.773 1.197 1.295q.276.399.516.87a7.1 7.1 0 0 1 2.945-.786C19.287 3.927 20 4.876 20 5.798V8a8 8 0 0 1-7 7.938v3.07c1.076-.669 2.662-1.454 4.758-1.978a1 1 0 1 1 .485 1.94c-3.218.805-5.036 2.29-5.45 2.658c-.233.208-.464.372-.793.372c-.325 0-.556-.16-.787-.367c-.401-.358-2.22-1.854-5.456-2.663a1 1 0 1 1 .486-1.94c2.095.524 3.68 1.31 4.757 1.978v-3.07A8 8 0 0 1 4 8V5.784c0-.909.692-1.85 1.807-1.82c.734.02 1.854.168 3 .763c.152-.298.32-.577.495-.83c.36-.523.773-.97 1.197-1.296"></path></g></svg>',
      tipIcon: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="12" height="12" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6.83 17.08c7.07 4.243 12.727-1.414 12.02-12.02C8.244 4.353 2.587 10.01 6.83 17.08m0 0q0 0 0 0m0 0L5 18.91m1.83-1.828l3.827-3.829"></path></svg>',
      scale: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Mealybug_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width ="20" height="20">',
      blackvineweevil: '<img src="https://cdn.shopify.com/s/files/1/0270/0266/7060/files/Black_vine_weevil_-_off-white_-_Pest_Icon_-_GS_Koppert_2026.svg?v=1788980222" width ="20" height="20">',
      none: ''
    };

    function loadQuestionData(sectionId) {
      var script = document.getElementById('kc-question-data-' + sectionId);
      if (!script) return {};

      try {
        var parsed = JSON.parse(script.textContent || script.innerText || '{}');
        var map = {};

        if (parsed && Array.isArray(parsed.questions)) {
          parsed.questions.forEach(function (q) {
            if (!q.viewId) return;

            map[q.viewId] = {
              title: q.title || '',
              subtitle: q.subtitle || '',
              backTarget: q.backTarget || 'welcome',
              options: (Array.isArray(q.options) ? q.options : []).map(function (opt) {
                var iconKey = opt.icon || 'none';
                var iconSvg = ICONS[iconKey] || ICONS.none;

                return {
                  label: opt.label || '',
                  target: opt.target || '',
                  icon: iconSvg
                };
              })
            };
          });
        }

        return map;
      } catch (e) {
        console.error('Failed to parse question data JSON', e);
        return {};
      }
    }

    function loadResultData(sectionId) {
      var script = document.getElementById('kc-result-data-' + sectionId);
      if (!script) return {};

      try {
        var parsed = JSON.parse(script.textContent || script.innerText || '{}');
        var map = {};

        if (parsed && Array.isArray(parsed.results)) {
          parsed.results.forEach(function (r) {
            if (!r.viewId) return;

            map[r.viewId] = {
              tag: r.tag || '',
              title: r.title || '',
              description: r.description || '',
              backTarget: r.backTarget || 'welcome',
              tips: Array.isArray(r.tips) ? r.tips : [],
              links: Array.isArray(r.links) ? r.links : []
            };
          });
        }

        return map;
      } catch (e) {
        console.error('Failed to parse result data JSON', e);
        return {};
      }
    }

    var wrapper = document.querySelector('.kc-wrapper');
    var sectionId = wrapper ? wrapper.getAttribute('data-section-id') : '';

    var questionData = loadQuestionData(sectionId || '');
    var resultData = loadResultData(sectionId || '');

    function buildFlows(startViewId, questionData, resultData) {
  var flows = [];

  function isQuestion(viewId) {
    return Object.prototype.hasOwnProperty.call(questionData, viewId);
  }

  function isResult(viewId) {
    return Object.prototype.hasOwnProperty.call(resultData, viewId);
  }

  function dfs(currentId, path, visited) {
    // Protect against cycles
    if (visited[currentId]) {
      return;
    }

    visited[currentId] = true;
    path.push(currentId);

    if (isResult(currentId)) {
      // End of a branch
      // Clone path to avoid mutation later
      flows.push(path.slice());
      path.pop();
      visited[currentId] = false;
      return;
    }

    var node = questionData[currentId];

    // If this node isn't a question or has no options, treat it as a leaf
    if (!node || !Array.isArray(node.options) || node.options.length === 0) {
      flows.push(path.slice());
      path.pop();
      visited[currentId] = false;
      return;
    }

    node.options.forEach(function (opt) {
      var target = opt.target;
      if (!target) {
        return;
      }

      dfs(target, path, visited);
    });

    path.pop();
    visited[currentId] = false;
  }

  dfs(startViewId, [], {});
  return flows;
}

    var BRANCH_FLOWS = buildFlows('plant-type', questionData, resultData);

    var CURRENT_FLOW = null;

    function findBranchForView(viewId) {
      for (var i = 0; i < BRANCH_FLOWS.length; i++) {
        var flow = BRANCH_FLOWS[i];
        if (flow.indexOf(viewId) !== -1) {
          return flow;
        }
      }
      return null;
    }

    function resolveCurrentFlow(currentId, targetId) {
      if (CURRENT_FLOW) {
        var existingCurrentIndex = CURRENT_FLOW.indexOf(currentId);
        var existingTargetIndex = CURRENT_FLOW.indexOf(targetId);

        if (existingCurrentIndex !== -1 && existingTargetIndex !== -1) {
          return;
        }
      }

      var candidateWithBoth = null;
      var candidateWithTarget = null;

      for (var i = 0; i < BRANCH_FLOWS.length; i++) {
        var flow = BRANCH_FLOWS[i];
        var hasTarget = flow.indexOf(targetId) !== -1;
        var hasCurrent = currentId ? flow.indexOf(currentId) !== -1 : false;

        if (hasTarget && hasCurrent && !candidateWithBoth) {
          candidateWithBoth = flow;
        } else if (hasTarget && !candidateWithTarget) {
          candidateWithTarget = flow;
        }
      }

      if (candidateWithBoth) {
        CURRENT_FLOW = candidateWithBoth;
      } else if (candidateWithTarget) {
        CURRENT_FLOW = candidateWithTarget;
      }
    }

    function updateProgress(viewId) {
      var bar = document.querySelector('[data-kc-progress-bar]');
      var label = document.querySelector('[data-kc-progress-label]');
      if (!bar || !label) return;

      if (viewId === 'welcome') {
        bar.style.width = '0%';
        label.textContent = '';
        return;
      }

      var flow = null;

      if (CURRENT_FLOW && CURRENT_FLOW.indexOf(viewId) !== -1) {
        flow = CURRENT_FLOW;
      } else {
        flow = findBranchForView(viewId);
      }

      if (!flow) {
        bar.style.width = '0%';
        label.textContent = '';
        return;
      }

      var index = flow.indexOf(viewId);
      if (index === -1) {
        bar.style.width = '0%';
        label.textContent = '';
        return;
      }

      var totalSteps = flow.length;
      var currentStep = index + 1;
      var ratio = currentStep / totalSteps;
      var percentage = Math.round(ratio * 100);

      bar.style.width = percentage + '%';
      label.textContent = 'Step ' + currentStep + ' of ' + totalSteps;
    }

    function renderQuestion(viewId) {
      var data = questionData[viewId];
      if (!data) return;

      var view = document.getElementById(viewId);
      if (!view) return;

      var html =
        '<a href="#' + data.backTarget + '" class="kc-btn-back">← Back</a>' +
        '<h2 class="kc-title">' + data.title + '</h2>' +
        '<p class="kc-subtitle">' + data.subtitle + '</p>' +
        '<div class="kc-btn-grid">';

      data.options.forEach(function (option) {
        html +=
          '<a href="#' + option.target + '" class="kc-options btn btn--primary">' +
            '<span class="kc-options__icon">' + (option.icon || '') + '</span>' +
            '<span class="kc-options__label">' + option.label + '</span>' +
          '</a>';
      });

      html += '</div>';
      view.innerHTML = html;
    }

    function renderResult(viewId) {
      var data = resultData[viewId];
      if (!data) return;

      var view = document.getElementById(viewId);
      if (!view) return;

      var tipsHtml = '';
      data.tips.forEach(function (tip) {
        tipsHtml +=
          '<li class="kc-tip">' +
            '<span class="kc-tip__icon-wrap">' +
              ICONS.tipIcon +
            '</span>' +
            '<span class="kc-tip__text">' + tip + '</span>' +
          '</li>';
      });

      var linksHtml = '';
      if (Array.isArray(data.links) && data.links.length > 0) {
        linksHtml += '<div class="kc-btn-grid">';
        data.links.forEach(function (link) {
          linksHtml +=
            '<a href="' + link.href + '" class="btn btn--primary">' +
              link.label +
            '</a>';
        });
        linksHtml += '</div>';
      }

      var html =
        '<a href="#' + data.backTarget + '" class="kc-btn-back">← Back</a>' +
        '<span class="kc-tag kc-tag--result">' + data.tag + '</span>' +
        '<div class="kc-result-card">' +
          '<h3>' + data.title + '</h3>' +
          '<p>' + data.description + '</p>' +
          '<ul class="kc-tip-list">' + tipsHtml + '</ul>' +
          linksHtml +
          '<a href="#welcome" class="kc-btn-restart">Start over</a>' +
        '</div>';

      view.innerHTML = html;
    }

    function switchView(targetId) {
      document.querySelectorAll('.kc-view').forEach(function (view) {
        view.classList.remove('active');
      });

      var targetView = document.getElementById(targetId);
      if (targetView) {
        targetView.classList.add('active');
      }

      if (targetId === 'welcome') {
        CURRENT_FLOW = null;
      }

      updateProgress(targetId);
    }

    function initCountdown() {
  var el = document.querySelector('[data-kc-countdown]');
  if (!el) {
    console.warn('KC Countdown: no [data-kc-countdown] element found');
    return;
  }

  var deadlineStr = el.getAttribute('data-kc-countdown-deadline');
  if (!deadlineStr) {
    console.warn('KC Countdown: data-kc-countdown-deadline is missing');
    return;
  }

  console.log('KC Countdown: deadline string =', deadlineStr);

  var deadline = new Date(deadlineStr);
  if (isNaN(deadline.getTime())) {
    console.error('KC Countdown: invalid deadline date', deadlineStr);
    return;
  }

  var timeEl = el.querySelector('[data-kc-countdown-time]');
  if (!timeEl) {
    console.warn('KC Countdown: no [data-kc-countdown-time] element found');
    return;
  }

  function formatRemaining(ms) {
    if (ms <= 0) return null;

    var totalSeconds = Math.floor(ms / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return {
      days: String(days).padStart(2, '0'),
      hours: String(hours).padStart(2, '0'),
      minutes: String(minutes).padStart(2, '0'),
      seconds: String(seconds).padStart(2, '0')
    };
  }

  function tick() {
    var now = new Date();
    var remaining = deadline.getTime() - now.getTime();
    var parts = formatRemaining(remaining);

    if (!parts) {
      timeEl.textContent = 'Offer ended';
      clearInterval(timerId);
      return;
    }

    timeEl.innerHTML =
      '<div class="kc-countdown__grid">' +
        '<div class="kc-countdown__unit">' +
          '<div class="kc-countdown__number">' + parts.days + '</div>' +
          '<div class="kc-countdown__unit-label">Days</div>' +
        '</div>' +
        '<div class="kc-countdown__unit">' +
          '<div class="kc-countdown__number">' + parts.hours + '</div>' +
          '<div class="kc-countdown__unit-label">Hours</div>' +
        '</div>' +
        '<div class="kc-countdown__unit">' +
          '<div class="kc-countdown__number">' + parts.minutes + '</div>' +
          '<div class="kc-countdown__unit-label">Minutes</div>' +
        '</div>' +
        '<div class="kc-countdown__unit">' +
          '<div class="kc-countdown__number">' + parts.seconds + '</div>' +
          '<div class="kc-countdown__unit-label">Seconds</div>' +
        '</div>' +
      '</div>';
  }

  tick();
  var timerId = setInterval(tick, 1000);
}

    function initWizard() {
      Object.keys(questionData).forEach(function (key) {
        renderQuestion(key);
      });
      Object.keys(resultData).forEach(function (key) {
        renderResult(key);
      });

      var welcomeView = document.getElementById('welcome');
      if (welcomeView && !welcomeView.classList.contains('active')) {
        welcomeView.classList.add('active');
      }

      updateProgress('welcome');

      document.addEventListener('click', function (e) {
        var rawTarget = e.target;
        if (!(rawTarget instanceof HTMLElement)) return;

        var link = rawTarget.closest('a[href^="#"]');
        if (!link) return;

        e.preventDefault();

        var href = link.getAttribute('href');
        if (!href) return;

        var targetId = href.substring(1);
        if (!targetId) return;

        var activeView = document.querySelector('.kc-view.active');
        var currentId = activeView ? activeView.id : null;

        if (currentId && targetId !== 'welcome') {
          resolveCurrentFlow(currentId, targetId);
        }

        if (document.startViewTransition) {
          document.startViewTransition(function () {
            switchView(targetId);
          });
        } else {
          switchView(targetId);
        }
      });
      initCountdown();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWizard);
    } else {
      initWizard();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
